/*@flow*/
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";
import {InstrumentCategories} from "../constants/enums";
import lowerFirst from 'lodash/lowerFirst';

export const black = '#000000';
export const white = '#FFFFFF';
export const primary = '#6442E8';
export const secondary = '#193e6d';
export const disabledLight = '#d8d8d8';
export const disabledDark = '#808080';
export const instructions = '#6697d8';
export const notation = '#8e44ad';
export const audio = '#00838f';
export const video = '#ad1457';
export const whiteboard = '#f26663';
export const yellow = '#f9a825';
export const orange = '#ef6c00';
export const green = '#03a678';
export const successGreen = '#30d06c';
export const errorRed = '#cc1d35';
export const galleryBg = '#f8f8f8';
export const xmlBg = '#f5f3f0';
export const headerBg = '#f8f9fe';
export const instructionsBg = '#e1e9f5';
export const notationBg = '#ece3ef';
export const audioBg = '#dbf1f0';
export const videoBg = '#fadfed';
export const whiteboardBg = '#ffe4e5';
export const typoDark = '#363437';
export const typoLight = '#b3b3b3';
export const primaryHover = '#1d14b5';
export const secondaryHover = '#001941';

export const lightBorder = '#F1F1F1';

// Gradients start pallete
export const whiteboardEnd = '#ff9891';
export const notationEnd = '#c073df';
export const videoEnd = '#e35183';
export const audioEnd = '#4fb3bf';
export const errorEnd = '#ff5a5f';
export const instructionsEnd = '#99c7ff';
export const secondaryEnd = '#4c689c';
export const greenEnd = '#55d8a7';
export const orangeEnd = '#ff9d3f'
export const yellowEnd = '#ffd95a'

export const instrumentColorMap = {
    percussion: notation,
    synthesizer: audio,
    pianoAndKeys: whiteboard,
    electronicBeat: errorRed,
    drums: green,
    vocals: notation,
    strings: instructions,
    bass: whiteboard,
    woodwindsAndBrass: yellow,
    guitar: successGreen
};
export const colorByTiers = [errorRed, green, whiteboard, yellow, audio, video, orange]
export const colorPaletteList = [
    {
        name: 'orange',
        value: [orange, orangeEnd]
    }, {
        name: 'notation',
        value: [notation, notationEnd]
    }, {
        name: 'instructions',
        value: [instructions, instructionsEnd]
    }, {
        name: 'audio',
        value: [audio, audioEnd]
    }, {
        name: 'yellow',
        value: [yellow, yellowEnd]
    }, {
        name: 'video',
        value: [video, videoEnd]
    }, {
        name: 'whiteboard',
        value: [whiteboard, whiteboardEnd]
    }
];
export const colorLessonsList = [
    [orange, orangeEnd],
    [video, videoEnd],
    [audio, audioEnd],
    [yellow, yellowEnd],
    [whiteboard, whiteboardEnd],
    [green, greenEnd],
    [errorRed, errorEnd],
    [notation, notationEnd],
    [instructions, instructionsEnd],
];

export const categoryColors = [whiteboard, yellow, audio, green, instructions, orange, video, notation, errorRed];

/**
 * Return a color by instrument
 * @param instruments
 * @returns {String}
 */
export function getColorByInstrument(instruments: Array<Object>) {
    if (isEmpty(instruments) || isUndefined(instruments[0]) || instruments[0] === null) {
        return yellow;
    }
    return instrumentColorMap[lowerFirst(InstrumentCategories(instruments[0].category))] || yellow;
}

export function getColorByTier(tier: number) {
    return colorByTiers[tier || 0];
}

export function getLessonColorBySerialNum(serialNum: number) {
    const num = serialNum % 9;
    return colorLessonsList[num || 0];
}

export function getGradientStyleBySerialNum(serialNum: number) {
    const gradient = getLessonColorBySerialNum(serialNum);
    return {
        backgroundImage: `linear-gradient(to right, ${gradient[0]}, ${gradient[1]})`
    };
}

export const colorPaletteMarkupPanel = [video, whiteboard, orange, yellow, green, audio, instructions, secondary, notation, black, white, whiteboardBg, audioBg, instructionsBg, notationBg];

export const defaultColorMarkupPanel = colorPaletteMarkupPanel[9];

export const defaultTextColorMarkupPanel = colorPaletteMarkupPanel[1];

export const defaultHighlighterColor = colorPaletteMarkupPanel[3];

export const thicknessMarkupPanel = [2, 4, 8, 12, 18];

export const defaultThickness = thicknessMarkupPanel[2];

export function hexToRGB(hex: string, alpha: string) {

    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
  
    if (alpha) {
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  
    return `rgb(${r}, ${g}, ${b})`;
}